import React, { useState } from 'react';
import { SlidersHorizontal, List } from 'lucide-react';
import { LaborOverrideModal } from './LaborOverrideModal';
import { LaborManageOverridesModal } from './LaborManageOverridesModal';

/**
 * Acciones de overrides: crear y listar (vista Fábrica o Empleado).
 */
export function LaborOverrideSetup({
  factoryId,
  factoryCode,
  year,
  calendarId = null,
  defaultEmployeeId = null,
  lockEmployeeScope = false,
  onAfterChange,
}) {
  const [createOpen, setCreateOpen] = useState(false);
  const [listOpen, setListOpen] = useState(false);
  const [lastMessage, setLastMessage] = useState(null);

  const handleSuccess = (message) => {
    setLastMessage({ type: 'success', text: message });
    onAfterChange?.();
  };

  const label = lockEmployeeScope ? 'Overrides del empleado' : 'Overrides de planta';

  return (
    <>
      <div className="mb-4 flex flex-wrap items-center gap-3 rounded-lg border border-gray-700 bg-gray-800/80 p-3">
        <span className="text-sm text-gray-400 mr-1">{label}:</span>
        <button
          type="button"
          onClick={() => setCreateOpen(true)}
          disabled={!factoryId}
          className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-amber-600 hover:bg-amber-500 text-white text-sm font-medium disabled:opacity-50"
        >
          <SlidersHorizontal className="w-4 h-4" />
          Crear override
        </button>
        <button
          type="button"
          onClick={() => setListOpen(true)}
          disabled={!factoryId}
          className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-gray-600 hover:bg-gray-500 text-white text-sm font-medium disabled:opacity-50"
        >
          <List className="w-4 h-4" />
          Ver overrides
        </button>
        {lastMessage?.type === 'success' && (
          <span className="text-sm text-emerald-400">{lastMessage.text}</span>
        )}
      </div>

      <LaborOverrideModal
        isOpen={createOpen}
        onClose={() => setCreateOpen(false)}
        factoryId={factoryId}
        factoryCode={factoryCode || String(factoryId)}
        defaultYear={year}
        defaultCalendarId={calendarId}
        defaultEmployeeId={defaultEmployeeId}
        lockEmployeeScope={lockEmployeeScope}
        onSuccess={() =>
          handleSuccess(
            lockEmployeeScope
              ? 'Override del empleado creado. Actualiza el calendario para ver el cambio.'
              : 'Override creado. Actualiza el calendario para ver el cambio.'
          )
        }
      />

      <LaborManageOverridesModal
        isOpen={listOpen}
        onClose={() => setListOpen(false)}
        factoryId={factoryId}
        factoryCode={factoryCode || String(factoryId)}
        defaultYear={year}
        defaultCalendarId={calendarId}
        filterEmployeeId={lockEmployeeScope ? defaultEmployeeId : null}
        onAfterChange={onAfterChange}
      />
    </>
  );
}
